import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const GET_USER_NAMES_USER_FRAGMENT = gql(`
  fragment getUserNames_user on UserFields {
    id
    name
  }
`);

interface GetUserNamesOptions {
  currentUser?: { id: string };
  limit?: number;
}

const getUserNames = (
  users: DocumentType<typeof GET_USER_NAMES_USER_FRAGMENT>[],
  { currentUser, limit }: GetUserNamesOptions = {},
) => {
  if (!users.length) return '';

  const orderedUsers = users.toSorted((a, b) => {
    if (a.id === currentUser?.id) return -1;
    if (b.id === currentUser?.id) return 1;
    return 0;
  });

  const displayedUsers = limit ? orderedUsers.slice(0, limit) : orderedUsers;

  const userList = displayedUsers
    .map((user) => (user.id === currentUser?.id ? 'You' : user.name))
    .join(', ');

  const hiddenLength = limit ? Math.max(0, orderedUsers.length - limit) : 0;
  return hiddenLength ? `${userList}, and ${hiddenLength} more` : userList;
};

export default getUserNames;
